import { render, staticRenderFns } from "./activitiesDetailList.vue?vue&type=template&id=fee636fc&scoped=true&"
import script from "./activitiesDetailList.vue?vue&type=script&lang=js&"
export * from "./activitiesDetailList.vue?vue&type=script&lang=js&"
import style0 from "./activitiesDetailList.vue?vue&type=style&index=0&id=fee636fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee636fc",
  null
  
)

export default component.exports